import QuestionViewVerbalConversion from "./QuestionViewVerbalConversion";

export default class QuestionViewVisualLiquid extends QuestionViewVerbalConversion{
    constructor(question) {
        super(question);
		this._panel = new PIXI.mesh.NineSlicePlane(P3.assets.texture("ui_card_bg_9slice"), 88, 88, 88, 88);
		this._panel.position.set(30, 290);
		this._panel.width = 240;
		this._panel.height = 240;
		this._panel.pivot.set(this._panel.width * 0.5, this._panel.height * 0.5);
		this.addChild(this._panel);

		this._fillBG = new PIXI.Sprite(P3.assets.texture('measurement_volume_bg_0'));
		this._fillBG.anchor.set(0.5);
		this._fillBG.position.set(0, 290);
		this.addChild(this._fillBG);

		let step = (this._fillBG.height - 65) / question.steps;
		let substep = (this._fillBG.height - 65) / question.substeps;

		this._fill = new PIXI.Sprite(P3.assets.texture('measurement_volume_fill_0'));
		this._fill.height = substep * question.selectedSubStep;
		this._fill.anchor.set(0.5, 1);
		this._fill.position.set(-2.5, 0);
		this._fill.y += this._fillBG.height * 0.5 - 12;
		this._fillBG.addChild(this._fill);

		this._fillFG = new PIXI.Sprite(P3.assets.texture('measurement_volume_fg_0'));
		this._fillFG.anchor.set(0.5);
		this._fillFG.position.set(0, 0);
		this._fillBG.addChild(this._fillFG);

		this._maxText = new PIXI.extras.BitmapText(question.values[0].toString() + question.values[0]._unit, {font: "20px BBC Reith Sans", align: "center"});
		this._maxText.position.set(
			this._fillBG.width * 0.32,
			this._fillBG.height * 0.5 - step * question.steps
		);
		this._maxText.anchor.set(0, 1);
		this._maxText.tint = 0x0;
		this._fillBG.addChild(this._maxText);

		this._indicatorText = new PIXI.extras.BitmapText("0" + question.values[0]._unit, {font: "20px BBC Reith Sans", align: "center"});
		this._indicatorText.position.set(
			this._fillBG.width * 0.32,
			this._fillBG.height * 0.5// - step * 0
		);
		this._indicatorText.anchor.set(0, 1);
		this._indicatorText.tint = 0x0;
		this._fillBG.addChild(this._indicatorText);
    }

    getHeaderText() {
		const data = P3.assets.json("templates");
		this._answer = this._question.answer;

		let template = this._getTemplate(data);
		let text = template ? template.text : "";

		text = this._replaceUnits(text);
		text = this._replaceItems(data.words.item_measurement, text);

		return text;
	}

	filterTemplate(x) {
		return true;
	}
}